export const config = {  
  "STRAPI_URL": process.env.REACT_APP_STRAPI_URL+"/api",   
  "MEDIA_URL": process.env.REACT_APP_STRAPI_URL,
}